'use strict';

yalwa.mobile = (function(pub) {

	pub = pub || {};

	let $window = null;
	let $document = null;
	let $body = null;
	let $headroom = null;
	let $main_col = null;
	let last_page;
	let pwa_prompt = null;
	let ajax_login_no_register = false;
	let ptr_active = false;
	let htabs_active = false;

	pub.init = function() {
		$window = jQuery(window);
		$document = jQuery(document);
		$body = jQuery('body');
		$headroom = jQuery('.headroom');
		$main_col = jQuery('.main_col');
		last_page = yalwa.basics.ls_get('last_page');
		yalwa.basics.ls_set('last_page', null);
		if (yalwa.v.areaID) {
			yalwa.basics.ls_set('last_areaID', parseInt(yalwa.v.areaID));
		}
		$document.on('keydown', function(event) {
			if (event.key === 'Enter') {
				jQuery(event.target).trigger('enterdown');
			}
		});
		//check if the clicked element has no_register class
		if (!yalwa.basics.is_logged_in()) {
			jQuery('.no_register').on('click', function(){
				ajax_login_no_register = true;
			});
		}
		yalwa.mobile.htabs.init();
		pub.scroll_check();
		scroll_watch();
		ptr_init();
		plp_init();

		init_loc_yalwa();
		if (yalwa.v.is_ios) {
			jQuery('body').addClass('detected_ios');
		}
		if (yalwa.v.read_only_announcement) {
			yalwa.mobile.show_announcement(yalwa.v.read_only_announcement);
		}

		jQuery(document).on('click', '.js-pwa_install', pub.install_pwa);
		if(jQuery('.js-pwa_promotion_topbar').length) {
			jQuery('.js-main_col').css({paddingTop: 183});
		}

	};

	pub.install_pwa = () => {
		pwa_prompt && pwa_prompt.prompt();
	};

	pub.install_pwa_prompt_available = () => {
		return pwa_prompt ? true : false;
	};

	function init_loc_yalwa() {
		pub.generic_shadow.init();
		check_routing();
		navigation_init();
		pwa_init();

		pub.check_for_detach();

		if (yalwa.v.is_phonegap) {
			if(yalwa.v.is_dol_app) {
				yalwa.basics.load_js(yalwa.basics.static_url('js') + 'mobile/dol_app.js', function() {
					yalwa.mobile.cordova_dol.init();
					yalwa.basics.app_module_load_handler.deferred.resolve('resolve');
				});
			} else {
				yalwa.mobile.cordova.init();
			}
		}

		init_default_form_elements();
		if (['mc', 'myprofile', 'settings', 'account_activation', 'dol'].indexOf(yalwa.basics.get_routing()) === -1) {
			yalwa.mobile.stop_invisible_start();
		}

		yalwa.basics.state.init();
		window.addEventListener('beforeinstallprompt', e => {
			// Prevent Chrome from showing the native AppInstall banner
			e.preventDefault();

			// Stash the event so it can be triggered later.
			pwa_prompt = e;
			$document.trigger('can_show_promo_on_headroom');
			yalwa.basics.set_cookie('can_install_pwa', 1, 5184000); // 60 days
		});

		check_heights();
		$window.on('resize', check_heights);
		pub.ali.init();
	}

	// sometimes viewport and window height are not the same, e.g. iOS showing the bottom tab bar
	function check_heights() {
		var $ruler = jQuery('<div class="js-ruler" style="position:fixed;height:100vh;width:0;top:0;"></div>');
		let $html = jQuery('html');
		$html.append($ruler);
		let axis = Math.abs(window.orientation);
		// let w = axis === 90 ? $ruler[0].offsetHeight : window.innerWidth;
		let h = axis === 90 ? window.innerWidth : $ruler[0].offsetHeight;
		jQuery('.js-ruler').remove();
		$html.toggleClass('viewport_height_trimmed', (axis === 90 && $window.height() !== h));
	}

	function pwa_init() {

		var cookie_name = yalwa.v.DATING_PWA_ENABLED ? 'pwa_dating' : 'pwa';
		if (yalwa.v.DATING_PWA_ENABLED) {
			var cookie_name_inverted = !yalwa.v.DATING_PWA_ENABLED ? 'pwa_dating' : 'pwa';
			if (window.navigator.cookieEnabled && yalwa.basics.get_cookie(cookie_name_inverted)) {
				yalwa.basics.set_cookie(cookie_name_inverted, 0, -1);
			}
		}
		if(yalwa.basics.is_pwa() && window.navigator.cookieEnabled && !yalwa.basics.get_cookie(cookie_name)) {
			yalwa.basics.set_cookie(cookie_name, yalwa.v.is_ios ? 'ios' : 'android');
			if (yalwa.basics.get_cookie(cookie_name)) {
				yalwa.basics.reload();
				return;
			}
		}
		if(!yalwa.basics.is_pwa() && yalwa.basics.get_cookie(cookie_name)) {
			yalwa.basics.set_cookie(cookie_name, 0, -1);
			if (!yalwa.basics.get_cookie(cookie_name)) {
				yalwa.basics.reload();
				return;
			}
		}
		if (navigator.storage && navigator.storage.persist) {
			navigator.storage.persist();
		}
		if(yalwa.basics.is_pwa()) {
			jQuery('html').addClass('pwa');
		}

		jQuery('.js-pwa_promotion_close').on('click', () => {
			jQuery('.js-pwa_promotion_topbar').remove();
			jQuery('.js-main_col').css({paddingTop: 53});
			yalwa.basics.set_cookie('pwa_promo', 1, 2592000); // 30 days
		});
	}

	pub.force_repaint = function(element, options) {
		// force browser (safari!!!) to repaint visual changes.
		// We also noticed PWAs that the old versions of chrome use, also have the same problem probably. see #41021
		options = options || {};
		var force = options.force || false;
		var type = options.type || 2;
		if(!yalwa.v.is_ios && !force) {
			return;
		}

		switch(type) {
			case 1:
				// force repaint with width change
				jQuery(element).width(jQuery(element).width() + 1);
				window.setTimeout(function() {
					jQuery(element).width(jQuery(element).width() - 1);
				},800);
				break;
			case 2:
				// force repaint with max-width change
				var max_width = jQuery(element).css('max-width') || '';
				jQuery(element).css('max-width', jQuery(element).width());
				window.setTimeout(function() {
					jQuery(element).css('max-width', max_width);
				},400);
				break;
			case 3:
				window.setTimeout(function() {
					var clone = jQuery(element).clone();
					clone.insertAfter(jQuery(element));
					jQuery(element).remove();
				},400);
				break;
			case 4:
				// force repaint with hide/display change
				jQuery(element).hide();
				window.setTimeout(function() {
					jQuery(element).show();
				},400);
		}
	}
	pub.ltabs = (function(pub) {

		pub = pub || {};
		var class_chosen = 'ltabs__item--chosen';
		var class_item = 'js-ltabs_item';
		var class_container = 'js-ltabs';
		var class_track = 'js-ltabs_track';

		pub.init = function() {
			jQuery('.' + class_container).each(init_instance);
			jQuery('.' + class_item).on('click', item_click);
		};

		function init_instance() {
			var $ltabs = jQuery(this);
			var hammertime = new Hammer($ltabs[0], {});
			hammertime.on('swipeleft swiperight', tab_swipe);
			get_track($ltabs).css({
				width: (100 / (get_tab_count($ltabs) * 2)) + '%',
				transform: 'translateX(' + get_percent($ltabs) + '%)'
			});
		}

		function get_percent($ltabs) {
			var $items = $ltabs.find('.' + class_item);
			var $item_selected = $items.filter('.' + class_chosen);
			return 50 + (200 * ($item_selected.index() - 1));
		}

		function item_click() {
			var $this = jQuery(this);
			$this.siblings('.' + class_item).removeClass(class_chosen);
			$this.addClass(class_chosen);
			var $ltabs = get_container($this);
			move_percent($ltabs);
			$document.trigger($ltabs.data('event'), $this.data('value'));
		}

		function move_percent($ltabs) {
			get_track($ltabs).css({transform: 'translateX(' + get_percent($ltabs) + '%)'});
		}

		function get_tab_count($ltabs) {
			return $ltabs.find('.' + class_item).length;
		}

		function get_track($ltabs) {
			return $ltabs.find('.' + class_track);
		}

		function get_container(element) {
			return jQuery(element).closest('.' + class_container);
		}

		function get_selected($ltabs) {
			return $ltabs.find('.' + class_item).filter('.' + class_chosen);
		}

		function tab_swipe(e) {
			pub.move(get_container(e.target), e.type === 'swipeleft' ? 'right' : 'left');
		}

		pub.move = function($ltabs, direction) {
			var $item_selected = get_selected($ltabs);
			var $next = direction === 'left' ? $item_selected.prev() : $item_selected.next();
			if ($next.length) {
				$next.trigger('click');
			}
		};

		return pub;

	}(pub.ltabs));

	pub.htabs = (function(pub) {

		pub = pub || {};

		var $items;
		var $htabs;
		var $wrap;
		var $track;
		var $sections;
		var class_chosen = 'htabs__item--chosen';
		var max;
		var pan_delta = 0;
		var start = 0;
		var is_back = false;
		var is_init = false;
		var get_parameter_name = 'tab';
		var abort_check = null;

		pub.init = function() {
			$htabs = jQuery('.js-htabs');
			if (!$htabs.length) {
				return;
			}
			$items = jQuery('.js-htabs_item');
			$wrap = jQuery('.js-htabs_wrap');
			$track = jQuery('.js-htabs_track');
			$sections = jQuery('.js-htab_section');
			max = calc_max();
			if ($htabs.data('get_parameter_name') !== undefined) { // "" means last path item is used
				get_parameter_name = $htabs.data('get_parameter_name');
			}
			$window.on('orientationchange', function() {
				$window.one('resize', function() {// #38391 https://stackoverflow.com/a/49383279/333864
					max = calc_max();
				});
			});

			jQuery('.js-main_col').css({paddingTop: jQuery('.js-headroom').outerHeight()});

			if (!pub.is_active()) {
				return;
			}
			is_init = true;


			$items.on('click', item_click);
			//new Hammer($wrap[0], {}).on('panend', on_panend).on('panleft panright', on_pan);
			jQuery(document).on('htabs_settings', change_tab);
			jQuery(document).on('htabs_dol', change_tab);
			jQuery(document).on('htabs_profile', change_tab);
			jQuery(document).on('htabs_search', htabs_search);
			jQuery(document).on('htabs_dol_hashtags', change_tab);
			if (history.state && history.state.sectionID_to) {
				var $to_select = get_by_id(history.state.sectionID_to);
				if ($to_select.length) {
					set_selected($to_select);
				}
			}
			if (pub.get()) {
				set_selected(get_by_id(pub.get()));
			}
			if (get_selected().length) {
				$document.trigger($htabs.data('event'), get_selected().data('sectionid'));
				check_pan_position(get_selected());
				move_track();
				if (yalwa.v.is_ios || yalwa.v.is_dol) {
					setTimeout(move_track, 400); // workaround for bug / race condition
				}
			}
			yalwa.basics.state.register('htabs', function(a) {
				is_back = true;
				get_by_id(a.sectionID_from).trigger('click');
				is_back = false;
				return true;
			});
			$htabs.removeClass('htabs--init');
			is_init = false;
			load_horizontal_scroll('.htabs');
		};

		/**
		 * on mousedown init the horizontal scroll of the selected element
		 * @param $selector
		 */
		function load_horizontal_scroll($selector){
			const slider = document.querySelector($selector);
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', (e) => {
				isDown = true;
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});

			slider.addEventListener('mouseleave', () => {
				isDown = false;
			});
			slider.addEventListener('mouseup', () => {
				isDown = false;
			});
			slider.addEventListener('mousemove', (e) => {
				if(!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 3; //scroll-fast
				slider.scrollLeft = scrollLeft - walk;
			});
		}

		pub.is_active = function() {
			return $htabs.length;
		};

		pub.swipe_active = function() {
			return pub.is_active() && (['myprofile', 'settings', 'public_profile'].indexOf(yalwa.basics.get_routing()) !== -1);
		};

		pub.next = function() {
			var $next = get_selected().next();
			if ($next.length) {
				$next.trigger('click');
			}
			yalwa.mobile.gestures.fake_next();
		};

		pub.prev = function() {
			var $prev = get_selected().prev();
			if ($prev.length) {
				$prev.trigger('click');
			}
			yalwa.mobile.gestures.fake_prev();
		};

		pub.get = function() {
			if (get_parameter_name === '') {
				const tmp = document.location.pathname.match(/\/([^\/]+)\/?$/);
				return tmp ? tmp[1] : null;
			} else {
				return yalwa.basics.get_get(get_parameter_name);
			}
		};

		pub.set = function(value) {
			if (value === undefined) {
				return;
			}
			if (get_parameter_name === '') {
				return window.history.replaceState(undefined, null, document.location.href.replace(new RegExp('\\/' + pub.get() + '\\/?'), '/' + value + '/'));
			} else {
				var obj = {};
				obj[get_parameter_name] = value;
				return yalwa.basics.set_get(obj);
			}
		};

		pub.current = function() {
			return get_selected().data('sectionid');
		};

		pub.swipe_next_possible = function() {
			if (!$htabs.length) {
				return false;
			}
			return get_selected().index() < $items.length;
		};

		pub.swipe_prev_possible = function() {
			if (!$htabs.length) {
				return false;
			}
			return get_selected().index() > 1;
		};

		function get_by_id(id) {
			return $items.filter('[data-sectionid="' + id + '"]');
		}

		function htabs_search(e, sectionID) {
			if (!is_init) {
				const $e = jQuery('.js-htabs_item').filter('[data-sectionid="' + sectionID + '"]').eq(0);
				if ($e.length) {
					let url = $e.data('url');
					const area = yalwa.basics.get_get('area');
					const geoID = yalwa.basics.get_get('geoid');

					if(area && geoID) {
//						url = yalwa.basics.get_altered_url({'area': area, 'geoid': geoID}, true); // adds new params to the current URL. Idea: if a URL is passed, add the params to that URL
						url += `?area=${area}&geoid=${geoID}`;
					}

					// yalwa.mobile.page_will_unload(url);
					yalwa.basics.ga.event({category: 'navigation_click', action: 'tab_' + sectionID});
					yalwa.basics.navigate(url);
				}
			}
		}

		pub.register_abort_check = function(callback) {
			abort_check = callback;
		};

		function change_tab(e, sectionID) {
			var duration = is_init ? 0 : 200;
			var $to_hide = $sections.not('.hidden');
			var $to_show = $sections.filter('[data-htabs_sectionid="' + sectionID + '"]');
			// special case for dol hashtags as it is under profile sections DOM
			if (e.type === 'htabs_dol_hashtags') {
				$to_hide = $to_hide.not('[data-htabs_sectionid="profile"]');
				// if the user tapped the same tab which is already open do nothing just return
				if (!$to_show.hasClass('hidden')) {
					return;
				}
			}
			$to_show.trigger('htabs_show_start');
			$to_show.velocity('transition.' + ($to_hide.index() < $to_show.index() ? 'slideRightIn' : 'slideLeftIn'), {
				duration: duration, delay: $to_hide.length ? (duration - 20) : 0, begin: function() {
					yalwa.basics.show($to_show);
					yalwa.mobile.mainscroll_set(0);
					$to_show.trigger('htabs_show_done');
				}
			});
			if ($to_hide.length) {
				$to_hide.trigger('htabs_hide_start');
				$to_hide.velocity('transition.' + ($to_hide.index() < $to_show.index() ? 'slideLeftOut' : 'slideRightOut'), {
					duration: duration, begin: move_track, complete: function() {
						yalwa.basics.hide($to_hide);
						$to_hide.trigger('htabs_hide_done');
					}
				});
			}
			if (!is_back && !is_init && !$to_show.hasClass('js-no_url_changes')) {
				yalwa.basics.state.push({
					id: 'htabs',
					sectionID_from: $to_hide.data('htabs_sectionid'),
					sectionID_to: $to_show.data('htabs_sectionid')
				});
			}
		}

		function move_track() {
			var $item_selected = get_selected();
			if ($item_selected.outerWidth()) {
				$track.velocity({
					width: $item_selected.outerWidth(),
					translateX: $item_selected.position().left
				}, {duration: is_init ? 0 : 200});
			}
		}

		// var bounce_width = 1000;
		//
		// function on_pan(a) {
		// 	if (ptr_active) {
		// 		return;
		// 	}
		// 	htabs_active = true;
		// 	var deltaX = a.deltaX * 1.3 + start;
		// 	if (deltaX > bounce_width) {
		// 		deltaX = bounce_width;
		// 	}
		// 	if (deltaX < bounce_width && deltaX > max - bounce_width) {
		// 		var transform = 'translateX(' + (deltaX).toString() + 'px)';
		// 		pan_delta = deltaX;
		// 		window.requestAnimationFrame(function() {
		// 			$wrap.css({'transform': transform});
		// 		});
		// 	}
		//
		// }

		// function on_panend(e) {
		// 	if (ptr_active) {
		// 		return;
		// 	}
		// 	htabs_active = false;
		// 	var going_left = e.additionalEvent === 'panleft';
		// 	var smooth_factor = Math.abs(e.velocityX) * 200;
		// 	var goal = going_left ? pan_delta - smooth_factor : pan_delta + smooth_factor;
		// 	if (goal > 0) {
		// 		goal = 0;
		// 	}
		// 	if (goal < max) {
		// 		goal = max;
		// 	}
		// 	$wrap.velocity({translateX: [goal, pan_delta]}, {duration: 200, easing: 'easeOutQuart'});
		// 	start = goal;
		// }

		function calc_max() {
			var items_pixel = 0;
			$items.each(function(i, e) {
				items_pixel += parseInt(jQuery(e).outerWidth(), 10);
			});
			if ($wrap.width() > items_pixel) {
				return 0;
			}
			return $wrap.width() - items_pixel;
		}

		function item_click() {
			var $item = jQuery(this);
			if (abort_check && typeof(abort_check) === 'function') {
				if (abort_check($item.data('sectionid'))) {
					return false;
				}
			}
			if (set_selected($item, true) === false && !$item.closest('.js-htabs_cats').hasClass('htabs--cats')) {
				return;
			}
			if ($item.data('sectionid') === 'dating') {
				yalwa.basics.ga.event({
					category: 'dating_promo',
					action: 'header tab'
				});
			}
			check_pan_position($item);
			const $item_parent_htab = $item.closest('.js-htabs');
			const event = ($item_parent_htab && $item_parent_htab.length) ? $item_parent_htab.data('event') : $htabs.data('event');
			$document.trigger(event, $item.data('sectionid'));
		}

		function check_pan_position($item) {
			var tmp = ($window.width() - $main_col.width()) / 2; // when screen is bigger than max_width
			var offset_left = $item.offset().left - tmp;
			var l = (offset_left - ($item.outerWidth() / 3)) * -1;
			var tra = Math.min(0, Math.max(l + pan_delta, max));
			if ($item.index() === $items.length) {
				tra = max;
			}
			pan_delta = tra;
			var duration = is_init ? 0 : 200;
			$wrap.css({transition: 'transform ' + duration + 'ms'}).css({'transform': 'translateX(' + tra + 'px)'});
			setTimeout(function() {
				$wrap.css({transition: 'none'});
			}, duration + 50);
			start = pan_delta;
		}

		function set_selected($new_selected, from_click) {
			if (!$new_selected.length) {
				return false;
			}
			const active_tab_class = $new_selected.closest('.js-htabs').data('active-tab-class');
			class_chosen = (active_tab_class) ? active_tab_class : class_chosen;
			if (class_chosen !== 'htabs__item--chosen') {
				$new_selected.closest('.js-htabs').find('.js-htabs_item').removeClass('htabs__item--chosen');
			}
			if ($new_selected.hasClass(class_chosen)) {
				if (from_click && $htabs.hasClass('js-reload_on_selected')) {
					yalwa.basics.reload();
				}
				if (from_click && $htabs.hasClass('js-fire_on_selected')) {
					return true;
				}
				return false;
			}
			var before = pub.get();
			$items.removeClass(class_chosen);
			$new_selected.addClass(class_chosen);
			var sid = $new_selected.data('sectionid');
			if (['settings', 'public_profile', 'dol'].indexOf(yalwa.basics.get_routing()) !== -1) {
				if (!$new_selected.hasClass('js-no_url_changes')) {
					pub.set(sid);
					if (before !== sid && $sections.filter('[data-htabs_sectionid="' + sid + '"]').hasClass('js-htab_section_reload')) {
						yalwa.basics.reload();
					}
				}
			}
			return $new_selected;
		}

		function get_selected() {
			return $items && $items.length ? $items.filter('.' + class_chosen) : jQuery([]);
		}

		return pub;

	}(pub.htabs));

	pub.init_reveal_password = () => {
		jQuery('.js-reveal_password').on('touchend click', function(e) {
			const $icon = jQuery(this).children('.yicon');
			yalwa.basics.yicon_toggle($icon, 'eye-crossed-out', 'eye');
			yalwa.mobile.force_repaint($icon);

			const $input = jQuery(this).closest('label').find('input:visible');
			const type = yalwa.v.is_ios ? $input.attr('type') : $input.prop('type');
			const new_type = type === 'text' ? 'password' : 'text';
			$input.prop('type', new_type).attr('type', new_type);// .attr needed for iOS

			e.preventDefault();
			e.stopPropagation(); // so the keyboard doesn't reveal
		});
	};

	function init_default_form_elements() {

		yalwa.mobile.ltabs.init();

		jQuery('.js-validate_user_or_email').on('enterdown blur', function() {
			if (jQuery(this).val().search('@') === -1) {
				jQuery(this).prop('type', 'text');
			} else {
				jQuery(this).prop('type', 'email');
			}
		});

		jQuery('.unified_input--error').on('input', function() {
			jQuery(this).removeClass('unified_input--error');
		});
		jQuery('.js-spacebar_click').on('keypress', function(e) {
			if (e.keyCode === 32) { //spacebar
				jQuery(this).trigger('click');
				e.preventDefault();
			}
		});
	}

	pub.check_for_detach = function() {
		jQuery('.js-detach_body').each(detach_body);
	};

	function detach_body() {
		var $this = jQuery(this);
		if ($this.data('detach_to')) {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery($this.data('detach_to')));
		} else {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery('body'));
		}
	}

	function embedded_page_link_handler() {
		jQuery('a').each(function() {
			var href = jQuery(this).attr('href');
			if (!href) {
				return;
			}
			if (href.indexOf('#') === 0) {
				return;
			}

			jQuery(this).attr('target', '_blank');
		});
	}

	const htab_under_plp = (function(pub) {

		pub = pub || {};

		function show (clicked) {
			const $generic_shadow = jQuery('.js-generic_shadow');
			if(typeof ResizeObserver === 'function') {
				const resize_observer = new ResizeObserver(entries => {
					$generic_shadow.css({'margin-top': entries[0].contentRect.height});
				});
				resize_observer.observe(jQuery('.js-htabs_wrap')[0]);
			} else {
				// fallback
				let timeout = clicked ? 100 : 700;
				let htabs_outer_height = jQuery('.js-htabs_wrap').outerHeight();
				setTimeout(() => {
					$generic_shadow.css({'margin-top': htabs_outer_height});
				}, timeout);
			}
		}

		function hide () {
			jQuery('.js-generic_shadow').css({'margin-top': 0});
		}

		pub.handle = (options) => {
			if(!jQuery('.js-htabs_wrap')[0]) {
				return;
			}
			if (options.allowed) {
				show(options.clicked);
			} else {
				hide();
			}
		};

		return pub;
	})();

	let plp_params = {};
	const htab_params_default = {
		allowed:false,
	};
	function plp_init() { // plp = page load popup
		$body.on('plp_show', '.js-plp', function(event, params = {}) {
			plp_params = params;
			htab_under_plp.handle(params.htab ? params.htab : htab_params_default);
			var $this = jQuery(this);
			if (!$this.hasClass('plp--static')) {
				yalwa.basics.show(jQuery('.js-plp_container'));
				jQuery('.js-plp_container').off('click.default');
				if ($this.hasClass('js-plp_hide_shadowclick') || ($this.find('.js-plp_ok').length && !$this.hasClass('js-plp_no_autohide') && !$this.find('.js-plp_confirm').length)) {
					jQuery('.js-plp_container').on('click.default', function() {
						$this.trigger('plp_hide');
					});
				}
				yalwa.mobile.generic_shadow[(params.is_queued ? 'show_queued' : 'show')]({onclick: function() {
						if(($this.find('.js-plp_close').length || $this.find('.js-plp_ok').length) && !$this.hasClass('js-no_outer_click_hide')) {
							$this.trigger('plp_hide', [{is_queued: params.is_queued}]);
						} else {
							jQuery('.js-generic_shadow').off();
						}
					}
				});
			}

			yalwa.basics.show($this);
			yalwa.basics.overlay.register('plp');
			if (yalwa.v.is_ios) {
				jQuery('.js-plp_container').on('touchmove', ios_prevent_background_scrolling);
			}
		});
		$body.on('plp_hide', '.js-plp', function(event, params = {}) {
			plp_params = params;
			var $this = jQuery(this);
			if (!$this.hasClass('plp--static')) {
				if (jQuery('.plp__close--on_top').length) {
					yalwa.basics.hide(jQuery('.plp__close--on_top'));
				}
				yalwa.basics.hide(jQuery('.js-plp_container'));
				yalwa.mobile.generic_shadow[(params.is_queued ? 'hide_queued' : 'hide')](true);
			}
			yalwa.basics.overlay.unregister('plp');
			yalwa.basics.hide($this);
			$this.trigger('plp_hidden');
		});
		jQuery('.js-plp').not('.js-plp_wait').each(function() {
			jQuery(this).trigger('plp_show', plp_params);
		});
		$body.on('click', '.js-plp_ok,.js-plp_close', function() {
			var $this = jQuery(this);
			var $plp_to_close;
			if ($this.closest('.js-plp').length) {
				$plp_to_close = $this.closest('.js-plp');
			} else {
				$plp_to_close = $this.parent().find('.js-plp');
			}
			if (!($this.is('a') && $plp_to_close.hasClass('plp--static'))) {
				$plp_to_close.trigger('plp_hide', plp_params);
			}
			if ($this.hasClass('js-plp_ok')) {
				$plp_to_close.trigger('plp_ok');
			}
		});
		$body.on('click', '.js-plp_confirm', function() {
			var $tmp = jQuery(this).closest('.js-plp');
			if ($tmp[0] && $tmp[0].fn_validate && !$tmp[0].fn_validate()) {
				return;
			}
			$tmp.trigger('plp_confirm');
			if (!$tmp.hasClass('js-plp_no_autohide')) {
				$tmp.trigger('plp_hide', plp_params);
			}
		});
	}

	pub.show_announcement = function(text) {
		if (yalwa.basics.ss_get('hide_announcement')) {
			return;
		}
		var $announcement = jQuery('<div class="announcement js-announcement" />')
		$announcement.html(
			yalwa.basics.yicon('warning', {pixel: 24, classes: 'announcement__warning'})
			+ '<span>' + text + '</span>'
			+ yalwa.basics.yicon('close', {
				pixel: 10,
				classes: 'announcement__close js-announcement_close'
			})
		);
		$announcement.prependTo(jQuery('.main_col'));
		jQuery('.js-announcement_close').on('click', function() {
			yalwa.basics.ss_set('hide_announcement', true);
			jQuery('.js-announcement').remove();
		});
	};

	pub.generic_shadow = (function(pub) {

		pub = pub || {};

		var defaults = {
			'background': 'var(--backdrop)',
			'zindex': '10',
			'onclick': function() {
				$document.trigger('generic_shadow_hide');
			},
			'callback': null
		};
		var $gs = null;
		var show_in_progress = false;
		var hide_in_progress = false;
		pub.show_in_progress = false;
		pub.hide_in_progress = false;

		pub.init = function() {
			$gs = jQuery('.js-generic_shadow');
			jQuery.Velocity.hook($gs, 'translateX', '-50%');
		};

		pub.showing = () => {
			return show_in_progress || $gs && $gs.is(':visible');
		};

		pub.queue = [];

		pub.queue_check = function() {
			if(pub.queue.length) {
				let queue = pub.queue.shift();
				queue();
			}
		};

		pub.show_queued = function(overwrites) {
			if(pub.hide_in_progress || pub.show_in_progress) {
				pub.queue.push(function(){return pub.show_queued(overwrites);});
				return;
			}
			pub.show_in_progress = true;
			show_in_progress = true;
			if (!$gs) {
				pub.init();
			}
			var options = jQuery.extend(defaults, overwrites);
			$gs.off('click').css({'z-index': options.zindex,'background': options.background});
			$gs.off('touchmove');
			if (options.onclick) {
				$gs.on('click' + (options.namespace ? ('.' + options.namespace) : ''), options.onclick);
			}

			var velocity_options = {
				duration: typeof(options.duration) === 'undefined' ? 150 : options.duration
			};

			velocity_options.complete =  function() {
				yalwa.mobile.generic_shadow.show_in_progress = false;
				show_in_progress = false;
				yalwa.mobile.generic_shadow.queue_check();
				if (options.callback) {
					options.callback();
				}
			};

			if ($gs.hasClass('hidden')) {
				yalwa.basics.show($gs).velocity('fadeIn', velocity_options);
				$document.trigger('generic_shadow_showing');
			} else {
				yalwa.basics.show($gs).velocity('finish', velocity_options);
				yalwa.mobile.generic_shadow.show_in_progress = false;
				show_in_progress = false;
				yalwa.mobile.generic_shadow.queue_check();
				if (options.callback) {
					options.callback();
				}
			}

			if (yalwa.v.is_ios) {
				$gs.on('touchmove', ios_prevent_background_scrolling);
			}
		};

		pub.hide_queued = function(no_animation) {
			if(pub.hide_in_progress || pub.show_in_progress) {
				pub.queue.push(function(){return pub.hide_queued(no_animation);});
				return;
			}
			pub.hide_in_progress = true;
			hide_in_progress = true;
			var deferred = jQuery.Deferred();
			$gs.velocity('fadeOut', {
				duration: no_animation === true ? 0 : 150,
				complete: function() {
					yalwa.basics.hide($gs);
					pub.hide_in_progress = false;
					hide_in_progress = false;
					pub.remove_events();
					yalwa.mobile.generic_shadow.queue_check();
					deferred.resolve();
				}
			});
			return deferred;
		};

		pub.show = function(overwrites) {
			// please do not use it anymore instead this please use queued version
			show_in_progress = true;

			if (!$gs) {
				pub.init();
			}
			var options = jQuery.extend(defaults, overwrites);
			$gs.off('click').css({'z-index': options.zindex,'background': options.background});
			$gs.off('touchmove');
			if (options.onclick) {
				$gs.on('click' + (options.namespace ? ('.' + options.namespace) : ''), options.onclick);
			}

			var velocity_options = {
				duration: typeof(options.duration) === 'undefined' ? 150 : options.duration
			};

			velocity_options.complete =  function() {
				show_in_progress = false;
				if (options.callback) {
					return velocity_options.complete = options.callback;
				}
			};

			if ($gs.hasClass('hidden')) {
				yalwa.basics.show($gs).velocity('fadeIn', velocity_options);
				$document.trigger('generic_shadow_showing');
			}
			if (yalwa.v.is_ios) {
				$gs.on('touchmove', ios_prevent_background_scrolling);
			}
		};

		pub.hide = function(no_animation) {
			// please do not use it anymore instead this please use queued version
			hide_in_progress =true;
			var deferred = jQuery.Deferred();
			$gs.velocity('fadeOut', {
				duration: no_animation === true ? 0 : 150,
				complete: function() {
					yalwa.basics.hide($gs);
					hide_in_progress = false;
					pub.remove_events();
					deferred.resolve();
				}
			});
			return deferred;
		};

		pub.remove_events = function() {
			$gs.off();
		};

		return pub;

	}(pub.generic_shadow));

	pub.stop_invisible_start = function() {
		if (window.invisible_timeout) {
			clearTimeout(window.invisible_timeout);
		}
		if ($body && $body.length && $body.hasClass('mbody--invisible')) {
			setTimeout(() => {
				if (last_page === 'back') {
					yalwa.mobile.gestures.fake_prev();
				}
				$body.removeClass('mbody--invisible');
			}, 200); // reduce FOUC
		}
	};

	pub.request_mc_counter_update = function() {
		jQuery.ajax({
			url: '/api/ajax/get_inbox',
			dataType: 'json'
		}).done(function(response) {
			pub.update_mc_counter(response.unread);
		});
	};

	pub.get_mc_count = function() {
		return jQuery('.js-context').filter('[data-context="inbox"]').data('menu_count') || 0;
	};

	pub.update_mc_counter = function(new_value) {
		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.cordova_send({action: 'mc_count', params: {value: new_value}});
		}
	};

	pub.b64toBlob = function(b64Data, contentType, sliceSize) { // still used? app pre 2.4.0?
		return yalwa.basics.b64_to_blob(b64Data, contentType, sliceSize);
	};

	pub.app_progress = function($container) {
		if (yalwa.basics.is_dol_app()) {
			return;
		}
		var speed = random_int(80, 500);
		yalwa.basics.progress.start('', {
			container: $container || ($headroom.hasClass('headroom--unpinned') ? $body : $headroom),
			trickleRate: random_int(15, 30) / 100,
			trickleSpeed: speed,
			speed: speed,
			minimum: random_int(10, 30) / 100
		});
	};

	function ios_prevent_background_scrolling(e)  {
		if (jQuery(e.target).hasClass('js-owl_carousel_img')) {
			return;
		}
		
		if (window.matchMedia('(max-height: 600px)').matches && jQuery(e.target).hasClass('plp__text')) {
			return; // https://trac.yalwa.net/ticket/42534#comment:37
		}
		e.preventDefault();
		e.stopPropagation();
	}

	function display_geolocation_error(code) {
		var label;
		yalwa.basics.progress.stop();
		switch (code) {
			case 1:
				label = 'mobile_notification_permission_denied';
				break;
			case 2:
				label = 'mobile_notification_position_unavailable';
				break;
			case 3:
				label = 'mobile_notification_timeout';
				break;
		}
		if (label) {
			yalwa.basics.label(label, 'main').done(function(value) {
				yalwa.basics.toast({message: value, type: 'warning'});
			});
		}
	}

	function init_ajax_reload_routine() { // ajax request e.g. in MC will fail, when logged out in the meantime
		var threshold = 3600;
		var timeoutID;
		var do_reload_on_return;

		$document.ajaxError(function(e, x) {
			if (x && x.responseText && x.responseText === 'ajax_autologin') {
				yalwa.basics.reload();
			}
		});

		$document.ajaxSuccess(function() {
			timeout_reset();
		});

		function timeout_reset() {
			yalwa.basics.ls_set('cordova_timer_started', yalwa.basics.unix());
			if (timeoutID) {
				window.clearTimeout(timeoutID);
			}
			timeoutID = window.setTimeout(function() {
				if (document.hidden) {
					do_reload_on_return = true;
				} else {
					yalwa.basics.ls_set('cordova_timer_started', 0);
					yalwa.basics.reload();
				}

			}, (threshold) * 1000);
		}

		timeout_reset();
		document.addEventListener("visibilitychange", function() {
			switch (document.visibilityState) {
				case 'visible':
					if (do_reload_on_return) {
						yalwa.basics.reload();
					} else if (yalwa.basics.ls_get('cordova_timer_started')) {
						if (yalwa.basics.unix() - yalwa.basics.ls_get('cordova_timer_started') > threshold) {
							yalwa.basics.reload();
						}
					}
					break;
			}
		});
	}

	var back_to_top = {
		timeout: null,
		last: null,
		hidden: true,
		init: function() {
			jQuery('.js-back_to_top').on('click', back_to_top.click_handler);
			if (yalwa.chat) {
				jQuery('.js-chat')
					.on('scroll', yalwa.basics.throttle(back_to_top.scroll_handler, 200));
			} else {
				$main_col
					.on('scroll.back_to_top', yalwa.basics.throttle(back_to_top.scroll_handler, 200));
			}
		},
		click_handler: function() {
			if (yalwa.chat) {
				// fixes iOS bug http://stackoverflow.com/a/10170170
				jQuery('.js-chat').scrollTop(0).css({'-webkit-transform': 'translate3d(0,0,0)'});
			} else {
				yalwa.mobile.mainscroll_set(0);
			}
			back_to_top.hide();
		},
		show: function() {
			if (back_to_top.hidden) {
				yalwa.basics.show(jQuery('.js-back_to_top'));
				back_to_top.hidden = false;
			}
		},
		hide: function() {
			if (!back_to_top.hidden) {
				yalwa.basics.hide(jQuery('.js-back_to_top'));
				back_to_top.hidden = true;
			}
		},
		scroll_handler: function() {
			if (!yalwa.chat || (yalwa.chat && yalwa.chat.current_view() === yalwa.chat.VIEW_LIST)) {
				var val = yalwa.chat ? jQuery('.js-chat').scrollTop() : yalwa.mobile.mainscroll_get();
				if (back_to_top.last && back_to_top.last > val && val > 250) {
					back_to_top.show();
					if (back_to_top.timeout) {
						window.clearTimeout(back_to_top.timeout);
					}
					back_to_top.timeout = window.setTimeout(back_to_top.hide, 2000);
				} else {
					if (back_to_top.last && back_to_top.last + 5 > val) {
						// goes only a bit down
					} else {
						if (back_to_top.timeout) {
							window.clearTimeout(back_to_top.timeout);
						}
						back_to_top.hide();
					}
				}
				back_to_top.last = val;
			}
		}
	};
	pub.back_to_top = back_to_top;

	function navigation_init() {
		jQuery('.js-history_back').on('click', function() {

			if (jQuery(this).hasClass('ybtb__li--disabled')) {
				return;
			}
			if (yalwa.v.is_phonegap && ['mc', 'dol', 'dol_onboarding', 'chp', 'dol_faq'].indexOf(yalwa.basics.get_routing()) === -1) {
				yalwa.mobile.app_progress();
			}
			if(typeof(jQuery('.js-history_back').data('url')) === 'string') {
				yalwa.basics.navigate(jQuery('.js-history_back').data('url'));
			}
			window.history.back();
		});
		pub.gestures.init();
		pub.auth.init();
	}

	pub.auth = (function(pub) {

		let loaded;
		let redirect_to;
		let success_handler;
		let init_register = false;
		let in_progress = false;

		pub = pub || {};

		pub.init = function() {
			yalwa.basics.auth.init();
		};

		pub.autoload = function() {
			return yalwa.basics.get_routing() === 'login' || yalwa.basics.get_routing() === 'registration';
		};

		pub.update_login_handlers = function() {
			const $login_buttons = jQuery('.js-headroom_login_button,.js-default_login,.js-default_register');
			$login_buttons.off('click.load_login').on('click.load_login', pub.show_dialog);
			if (!yalwa.basics.is_logged_in()) {
				const $links = jQuery('a[href*="\/my"]').not($login_buttons).not('[href*="\/activate"]');
				$links.off('click.load_login_links').on('click.load_login_links', function(e) {
					redirect_to = jQuery(this).attr('href');
					pub.show_dialog(e);
				});
			}
		};

		pub.show_dialog = function(e, forbid_cancel, default_register) {
			let deferred = jQuery.Deferred();
			var $login = jQuery('.js-login_modal');
			if (default_register || jQuery(this).hasClass('js-default_register')) {
				init_register = true;
			}
			// in dol context, always navigate to login page
			// helpful for pages like logout
			if (!loaded) {
				load_template_once('template_login', jQuery('.js-login_modal'), false, {dol: yalwa.v.is_dol}).done(() => {
					login_form_init(forbid_cancel);
					//GA Tracking for New registration layout
							jQuery('.js-ajax_login_relative_wrapper').html(jQuery('.js-login_modal'));
							jQuery('.js-login_form_toggle').toggleClass('hidden');
							jQuery('.js-logo_os, .js-dol_register_models').hide();
							jQuery('.info-wrapper').addClass('active');
							//GA Tracking New Reg layout
					deferred.resolve();
				});
				loaded = true;
			} else {
				if ($login.hasClass('hidden')) {
					dialog_show(forbid_cancel);
				} else {
					dialog_hide();
				}
				deferred.resolve();
			}
			if (e) {
				e.preventDefault();
			}
			return deferred.promise();
		};

		pub.register_success_handler = function(callback) {
			success_handler = callback;
		};

		function init_dialog_tabs() {
			if (ajax_login_no_register) {
				jQuery('.js-ltabs').addClass('hidden');
				jQuery('.js-ltabs_item[data-value="login"]').trigger('click');
				jQuery('.ajax_login__content').addClass('ajax_login__no_register_corners');
				ajax_login_no_register = false;
			} else {
				jQuery('.js-ltabs').removeClass('hidden');
				jQuery('.ajax_login__content').removeClass('ajax_login__no_register_corners');
			}
		}

		function dialog_show(forbid_cancel) {
			init_dialog_tabs();
			if (pub.autoload()) {
				jQuery('.js-login_modal').detach().addClass('ajax_login--static').appendTo(jQuery('.js-page_unique'));
			}
			yalwa.basics.show(jQuery('.js-login_modal'));
			$document.trigger('login_dialog_show', null);
		}

		function dialog_hide() {
			if (!pub.autoload()) {
				yalwa.mobile.generic_shadow.hide(true);
				yalwa.basics.hide(jQuery('.js-login_modal'));
			}
		}

		function dialog_remove() {
			jQuery('.js-login_modal').remove();
		}

		/**
		 * public method used from dol.js to hide login/register modal for google login
		 */
		pub.dialog_hide = dialog_hide;
		pub.dialog_remove = dialog_remove;

		function on_login_response(response) {
			if (response.success) {
				if (response.html) {
					jQuery('.js-page_unique').html(jQuery(response.html).find('.js-page_unique').html());
					yalwa.mobile.check_for_detach();
					dialog_hide();
					yalwa.v = jQuery.extend(yalwa.v,response.data);
					return;
				} else {
					yalwa.v.is_logged_in = true;
					yalwa.basics.toast({message: response.message, type: 'success'});
					jQuery('.js-headroom_login_button').remove();
					if (success_handler) {
						dialog_hide();
						success_handler();
					} else {
						dialog_hide();
						if (['dol', 'dol_onboarding'].indexOf(yalwa.basics.get_routing()) === -1) {
							setTimeout(function() {
								if (redirect_to) {
									yalwa.basics.navigate(redirect_to);
								} else if (['login', 'logout'].indexOf(yalwa.basics.get_routing()) !== -1) {
									yalwa.basics.navigate(yalwa.basics.get_get('continue') ? yalwa.basics.get_get('continue') : yalwa.v.chp_url);
								} else {
									yalwa.basics.reload();
								}
							}, 500);
						}
					}
					//make sure login success message visible enough
					window.setTimeout(function() {
						$document.trigger('login_successful', [response.has_dol, response.swipe_pledge_value]);
					},441);
					
					//Refresh the store only when it's premium country
					if(yalwa.basics.is_iap_active() && yalwa.v.premium_enabled_country) {
						yalwa.mobile.cordova_dol.cordova_send({action: 'iap_refresh_store'});
					}
					
				}
			} else {
				yalwa.basics.toast({message: response.message, type: 'error'});
			}
		}
		
		function twofactor_listeners(login_params) {
			jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
				const data = event.originalEvent.detail;
				login_params.otp_token = data.code || data.backup_code;
				login_params.remember_browser = data.remember_browser;
				yalwa.basics.auth.login(login_params).done((response) => {
					if (response.twofactor_needed) {
						jQuery('yalwa-twofactordialog')[0].show_invalid();
					} else {
						on_login_response(response);
					}
				});
			});
			jQuery(document).on_once('twofactor-dialog-closed.login', 'yalwa-twofactordialog', function() {
				in_progress = false;
			});
		}
		
		function login_form_init(forbid_cancel) {
			if (jQuery('.js-ajax_login_read_only').length) {
				yalwa.basics.toast({message: jQuery('.js-ajax_login_read_only').html().replace(/<br>/g, ''), type: 'error'});
				return;
			}
			yalwa.dol.magic_link.init_magic_link_btns();
			yalwa.dol.magic_link.check_for_failed_login();
			yalwa.mobile.ali.init();
			jQuery(document).on('ltabs_login', function() {
				var $container = jQuery('.js-login_section');
				if ($container.not('.hidden').data('value') === jQuery('.ltabs__item--chosen').data('value')) {
					return;
				}
				$container.toggleClass('hidden');
			});
			yalwa.mobile.ltabs.init();
			if (pub.autoload() && yalwa.basics.get_routing() === 'registration' || init_register) {
				jQuery('.js-ltabs_item[data-value="register"]').trigger('click');
			}
			init_register = false;
			jQuery('.js-ajax_register_email').on('enterdown', function() {
				jQuery('.js-ajax_register_submit').trigger('click');
				//adding this just not to submit the the form when user press enter on registration page (fixed issue in safari)
				jQuery('.js-register_form').on('submit', function() {
					return false;
				});
			});
			jQuery('.js-login_pw').on('enterdown', function() {
				jQuery('.js-ajax_login_submit').trigger('click');
			});
			jQuery('.js-ajax_login_submit').on('click', async function(e) {
				let form = jQuery('.js-ajax_login_submit').closest('form')[0];
				let validity_support = typeof form.checkValidity === 'function';
				if(validity_support && !form.checkValidity()) {
					return;
				} else {
					e.preventDefault();
				}
				if (in_progress) {
					return;
				}
				in_progress = true;
				let hash = await yalwa.basics.fingerprint.get_hash();
				const login_params = {
					email: jQuery('.js-login_id').val(),
					pw: jQuery('.js-login_pw').val(),
					keep: jQuery('.js-login_stay').prop('checked') ? 1 : 0,
					csrf_key: jQuery('.js-login_csrf').data('key'),
					csrf_value: jQuery('.js-login_csrf').val(),
					otp_token: null,
					fp_hash: hash,
					remember_browser: false,
				};
				yalwa.basics.auth.login(login_params).done(async (response) => {
					in_progress = false;
					if (response.twofactor_needed) {
						await yalwa.basics.import_js('shared/web_components/twofactor.js');
						jQuery('body').append('<yalwa-twofactordialog></yalwa-twofactordialog>');
						jQuery('yalwa-twofactordialog')[0].request_action('code', {email: jQuery('.js-login_id').val()});
						twofactor_listeners(login_params);
					} else {
						on_login_response(response);
					}
					
				});
			});
			jQuery('.js-ajax_register_submit').on('click', function(e) {
				let form = jQuery('.js-ajax_register_submit').closest('form')[0];
				let validity_support = typeof form.checkValidity === 'function';
				if(validity_support && !form.checkValidity()) {
					return;
				} else {
					e.preventDefault();
				}
				jQuery(this).prop('disabled', true);
				yalwa.basics.auth.register(jQuery('.js-ajax_register_email').val()).done(function(response) {
					if (response.success) {
						if (response.is_dol) {
							$document.trigger('dol_registration_email_success', [jQuery('.js-ajax_register_email').val()]);
						} else {
							dialog_hide();
							$body.append(response.html);
							setTimeout(function() {
								jQuery('.js-ajax_register_plp').trigger('plp_show').on('plp_hide', function() {
									$document.trigger('dol_show_ajax_login', null);
								});
							}, 500);
						}
					} else {
						e.target.disabled = false;
						if (yalwa.v.is_dol && response.email_exists) {
							if ((yalwa.basics.ls_get('dol_login_helper_seen_times') < 3
								&& !yalwa.basics.ls_get('dol_login_helper_DNS')) || response.is_dating_only_user) {
								setTimeout(() => {yalwa.dol_onboarding.show_login_helper(response.is_dating_only_user);}, 300);
							}
							jQuery('.js-ltabs_item[data-value="login"]').trigger('click');
							let $login_id = jQuery('.js-login_id');
							$login_id.val(jQuery('.js-ajax_register_email').val());
							$login_id.parent('.js-li').addClass('js-ali-infocus');
							// DEV-1039 BOF
							const $login_modal = jQuery('.js-login_modal');
							$login_modal.find('.js-login_id').focus();
							window.setTimeout(function(){
								$login_modal.find('.js-login_pw').focus();
							},200);
							// DEV-1039 EOF
							yalwa.basics.ga.event({
								category: 'dol_registration_error',
								action: 'email_exists',
							});
							//New onboarding flow
							//yalwa.dol_onboarding.reset_onboarding_cookie();
						} else {
							yalwa.basics.ga.event({
								category: 'dol_registration_error',
								action: response.text,
							});
							yalwa.basics.toast({title: response.title ,message: response.text, type: 'error'});
							//New onboarding flow
							//yalwa.dol_onboarding.reset_onboarding_cookie();
						}
					}
				});
			});
			jQuery('.js-social_media_login_info').on('click', function(event) {
				jQuery('.js-social_media_login_info_details').toggle();
				event.preventDefault();
			});
			if (yalwa.v.is_dol_app) {
				yalwa.basics.app_module_load_handler.is_loaded.done(function(res) {
					yalwa.mobile.cordova_dol.back_to_country.init();
				});
			}
			dialog_show(forbid_cancel);
			$document.trigger('login_dialog_initialized');
		}

		pub.update_logout_handlers = function() {
			jQuery('.js-logout').on('click', function() {
				yalwa.basics.before_logout();
			});
			jQuery('.js-logout').on('click', function(e) {
				e.preventDefault();
				// code to check if this use has #Dating account and set a value in LS
				yalwa.basics.auth.logout().done(function(response) {
					if (response.success) {
						if (yalwa.v.is_phonegap) {
							yalwa.mobile.cordova.cordova_send({action: 'logout', params: {}});
						}
						yalwa.basics.toast({message: response.message, type: 'success'});

						//Turn off auto sign-in for future visits
						if (yalwa.basics.auth.credential_api_support()) {
							navigator.credentials.preventSilentAccess();
						}

						setTimeout(function() {
							if (['login', 'logout'].indexOf(yalwa.basics.get_routing()) !== -1) {
								yalwa.basics.navigate(yalwa.basics.get_get('continue') ? yalwa.basics.get_get('continue') : yalwa.v.chp_url);
							} else {
								yalwa.basics.reload();
							}
						}, 200);
					} else {
						yalwa.basics.toast({message: response.message, type: 'error'});
					}
				});
				return false;
			});
		};

		return pub;

	}(pub.auth));

	function load_template_once(name, $to_check, $append_to, data) {
		$append_to = $append_to || jQuery('body');
		if ($to_check.length) {
			var deferred = jQuery.Deferred();
			deferred.resolve();
			return deferred.promise();
		}
		var data_final = {
			action: name,
		};
		if (data) {
			data_final = jQuery.extend(data_final, data);
		}
		return jQuery.ajax({
			url: yalwa.v.chp_url ? (yalwa.v.chp_url + 'api/ajax/general') : '/api/ajax/general',
			dataType: 'html',
			cache: false,
			data: data_final
		}).done(function(html) {
			$append_to.append(html);
		});
	}

	function ptr_init() {
		var slidebox = jQuery('.js-pullrefresh');
		if (!slidebox.length || typeof(Hammer) === 'undefined') {
			return;
		}
		const dol_htabs = yalwa.v.is_dol && jQuery('.js-ptr_dol').length;
		var container = dol_htabs ? jQuery('.js-ptr_dol') : $headroom;
		if (!container.length) {
			return;
		}
		container.on('touchcancel', ptr_hide);
		var slidebox_icon = slidebox.children('.js-pullrefresh_icon');
		var text = slidebox.children('.js-pullrefresh_text');
		var threshold = 50;
		var slowdown_factor = 0.4;
		var current_down = 0;
		var last_height = 0;
		var animation = null;
		var overflow_set = false;
		new Hammer.Manager(container[0], {
			recognizers: [[Hammer.Pan, {direction: Hammer.DIRECTION_VERTICAL}]]
		}).on('panend pandown panup', function(e) {
			var $target = jQuery(e.target);
			if ($target.hasClass('pullrefresh')) { // prevents unintended scrolls esspecially on ios
				return;
			}
			if (!dol_htabs && $target.closest('.js-htabs_item').length) {
				if (e.type === 'panend') {
					ptr_hide();
				}
				return;
			}
			if (htabs_active) {
				return;
			}
			ptr_active = true;
			e.preventDefault();
			ptr_pan(e);
		});

		function animate_dots() {
			jQuery('.js-dot').velocity('transition.fadeIn', {
				duration: 500,
				stagger: 200,
				loop: 3,
				complete: animate_dots
			});
		}

		function ptr_pan(ev) {
			if (!overflow_set) {
				jQuery('.js-headroom').css({overflow: 'visible'});
				overflow_set = true;
			}
			switch (ev.type) {
				case 'pandown':
				case 'panup':
					requestAnimationFrame(ptr_update_height);
					current_down = ev.deltaY * slowdown_factor;
					break;

				case 'panend':
					if (ev.deltaY * slowdown_factor >= threshold) {
						// jQuery('.js-headroom').css({overflow: ''});
						requestAnimationFrame(() => {
							ptr_set_height(50);
							slidebox_icon.addClass('loading');
							text.text(yalwa.v.lang.ptr_load);
							jQuery('.js-pullrefresh_text').append(' <span class="js-dot">.</span><span class="js-dot">.</span><span class="js-dot">.</span>');
							animate_dots();
						});
						yalwa.mobile.page_will_unload(location.href);
						window.setTimeout(function() { // avoid freezing on iOS
							window.yalwa.basics.reload();
						}, 100);
					} else {
						ptr_hide();
					}
					break;
			}
		}

		function ptr_set_height(height) {
			if (height !== last_height && height >= 0) {
				ptr_cancel_animation();
				container.css({
					'webkitTransform': 'translateY(' + Math.round(height) + 'px)',
					'transform': 'translateY(' + Math.round(height) + 'px)'
				});
				last_height = height;
			}
		}

		function ptr_cancel_animation() {
			cancelAnimationFrame(animation);
		}

		function ptr_hide() {
			jQuery('.js-headroom').css({overflow: ''});
			overflow_set = false;
			current_down = 0;
			ptr_set_height(0);
			animation = null;
			ptr_active = false;
		}

		function ptr_update_height() {

			ptr_set_height(current_down);
			if (current_down >= threshold) {
				slidebox_icon.addClass('arrow-up').removeClass('arrow-down');
				text.html(yalwa.v.lang.ptr_release);
			} else {
				slidebox_icon.removeClass('arrow-up').addClass('arrow-down');
				text.html(yalwa.v.lang.ptr_pull);
			}
		}
	}

// helper

	function random_int(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}

	function scroll_watch() {
		if (history.replaceState) {
			$main_col.on('scroll.save_position', function() {
				yalwa.basics.debounce(scroll_store, 200);
			});
		}
	}

	pub.mainscroll_set = function(value) {
		if ($main_col && $main_col.length) {
			$main_col.scrollTop(value || 0);
		}
	};

	pub.mainscroll_get = function() {
		return $main_col && $main_col.length ? $main_col.scrollTop() : null;
	};

	function scroll_restore() {
		yalwa.mobile.mainscroll_set(history.state.scroll_position);
	}

	pub.scroll_check = function() {
		if (history && history.state && history.state.scroll_position) {
			scroll_restore();
		}
	};

	function scroll_store() {
		if (yalwa.v.is_ios && !yalwa.v.is_phonegap) {
			return; // safari does this automatically and this also breaks the back-button functionality
		}
		yalwa.basics.state.extend({scroll_position: yalwa.mobile.mainscroll_get()}, true);
	}

	pub.yli = (function(pub) {

		pub = pub || {};

		pub.start = function($element, modifier) {
			$element.addClass('yli');
			if (modifier) {
				$element.addClass('yli--' + modifier);
			}
			setTimeout(() => {
				$element.addClass('yli--active');
			}, 200);
		};

		pub.stop = function($element, all) {
			if (all) {
				if (!$element[0]) {
					return;
				}
				const classes = $element[0].className.split(' ');
				for (let i = 0; i < classes.length; i++) {
					if (classes[i].indexOf('yli--') !== -1) {
						$element.removeClass(classes[i]);
					}
				}
			}
			$element.removeClass('yli yli--active');
		};

		pub.toggle = function($element, modifier) {
			if ($element.hasClass('yli--active')) {
				pub.stop($element);
			} else {
				pub.start($element, modifier);
			}
		};

		pub.progress = function($element, milliseconds, callback) {
			let $yli_progress = jQuery('<div class="js-yli_progress yli_progress"></div>');
			let color_darkened = $element.css('backgroundColor');
			color_darkened = '#000000';
			$yli_progress.css({backgroundColor: color_darkened});
			$element.addClass('yli_progress_parent').append($yli_progress);
			$yli_progress.velocity({width: '100%'}, {duration: milliseconds, complete: function() {
					if (typeof(callback) === 'function') {
						callback();
					}
					$yli_progress.remove();
					$element.removeClass('yli_progress_parent');
				}});
		};

		pub.progress_percentage = function($element, percent, callback) {
			const color_darkened = '#000000';
			if (!$element.find('.js-yli_progress').length) {
				const $yli_progress =  jQuery('<div class="js-yli_progress yli_progress"></div>');
				$yli_progress.css({backgroundColor: color_darkened});
				$element.addClass('yli_progress_parent').append($yli_progress);
			}
			const $progress_bar = $element.find('.js-yli_progress');
			jQuery.Velocity.hook($progress_bar, 'width', $progress_bar.width());
			$progress_bar.velocity(
				{
					width: percent_to_pixel(percent, $element.width())
				},
				{
					complete: function() {
						if (typeof(callback) === 'function') {
							callback();
						}
						if (percent === 100) {
							$progress_bar.remove();
							$element.removeClass('yli_progress_parent');
						}
					}
				}
			);
		};

		function percent_to_pixel(percent, element_width) {
			return (parseFloat(percent) && parseFloat(element_width)) ? element_width / 100 * percent : 0;
		}

		return pub;

	}(pub.yli));

// helper-end

	function check_routing() {
		yalwa.basics.check_routing();
		var routing = get_routing();
		switch (routing) {
			case 'logout':
			case 'registration':
				yalwa.basics.after_logout_handler();
				break;
			case 'terms':
			case 'privacy':
				embedded_page_link_handler();
				break;
			case 'dol_get_app':
				if (yalwa.v.redirect_link && dataLayer) {
					yalwa.basics.datalayer_push({
						'appStore': yalwa.v.app_store,
						'event': 'appstore_forward'
					});
					yalwa.basics.navigate(yalwa.v.redirect_link);
				}
				break;
		}
	}

	function get_routing() {
		if (yalwa.basics.get_routing) {
			return yalwa.basics.get_routing();
		}
		yalwa.v.routing = yalwa.v.routing || jQuery('html').data('routing');
		return yalwa.v.routing;
	}


	pub.handle_push = function(data) { // beware: used via cordova
		if (yalwa.push) {
			yalwa.push.process(data);
		}
	};

	pub.cordova = (function(pub) {

		pub = pub || {};

		let upload_timeout;

		pub.init = function() {
			// IOS App history_back button fix
			if(yalwa.v.is_ios) {
				if ((window.location.href === yalwa.v.chp_url && (document.referrer === '' || document.referrer === yalwa.v.chp_url))  || document.referrer === '' || window.history.length === 1) {
					yalwa.mobile.cordova.remove_backbutton();
				}
			}

			if (!yalwa.v.is_ios) {
				yalwa.mobile.cordova.apply_cordova_image_upload_listener();
			}

			if (get_routing() !== 'login') {
				if (!yalwa.v.is_read_only_mode) {
					if (yalwa.v.phonegap_logged_in && yalwa.v.phonegap_logged_in.userID) {
						yalwa.mobile.cordova.cordova_send({
							action: 'login_store',
							params: {data: yalwa.v.phonegap_logged_in, url: location.href}
						});
					} else if (window.location.hostname !== 'secure.locanto.info' && window.location.hostname !== 'm.uae.locanto.asia') {
						// no auto-login on checkout page, we don't have the session info there
						// no auto-login on aue personals page, causes infinite autologin attempts
					}
				}
				yalwa.mobile.cordova.cordova_send({
					action: 'country_info',
					params: {ID: yalwa.v.countryID, name: yalwa.v.phonegap_countryname}
				});
				yalwa.mobile.cordova.cordova_send({action: 'check_pending_pushes', params: {}});
			}
			init_ajax_reload_routine();

			$document.on('click', 'a[href][target="_blank"]', new_tab_links);
			if (yalwa.v.is_ios) {
				yalwa.basics.progress.load();
			} else {
				$window.on('beforeunload', function() {
					yalwa.mobile.page_will_unload();
				}); // safari doesnt support beforeunload and pagehide doesnt seem to work in inappbrowser
			}

			window.setTimeout(function() {
				yalwa.mobile.cordova.cordova_send({
					action: 'mc_count',
					params: {value: yalwa.mobile.get_mc_count()}
				});
			}, 2000);
		};

		//moved from basic.js
		pub.cordova_send = function(object) {
			if (yalwa.v.is_phonegap) {
				yalwa.v.send_pending = yalwa.v.send_pending || [];
				yalwa.v.send_pending.push(object);
			}
		};

		var last_file_input_clicked;

		pub.apply_cordova_image_upload_listener = function() {
			$body
				.off('click.image_request', 'input[type="file"]')
				.on('click.image_request', 'input[type="file"]', on_cordova_fileinput_click);
		};

		function on_cordova_fileinput_click(e) { // android only
			last_file_input_clicked = this;
			e.preventDefault(); //stop native click event!!!
			yalwa.mobile.cordova.cordova_send({
				action: 'image_request',
				params: {source: (jQuery(this).prop('cordova_camera') || jQuery(this).attr('cordova_camera')) ? 'camera' : 'folder'}
			});
			if (yalwa.mobile) {
				yalwa.mobile.app_progress();
			}
		}

		//**dataURL to blob**
		// see https://gist.github.com/wuchengwei/b7e1820d39445f431aeaa9c786753d8e
		pub.dataURLtoBlob = function(dataurl) { // beware: used via cordova
			var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {type: mime});
		};

		pub.b64_to_blob = function(b64Data, contentType, sliceSize) { // http://stackoverflow.com/a/16245768 needed for android app file upload
			try {
				contentType = contentType || '';
				sliceSize = sliceSize || 512;

				var byteCharacters = atob(b64Data);
				var byteArrays = [];

				for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
					var slice = byteCharacters.slice(offset, offset + sliceSize);

					var byteNumbers = new Array(slice.length);
					for (var i = 0; i < slice.length; i++) {
						byteNumbers[i] = slice.charCodeAt(i);
					}

					var byteArray = new Uint8Array(byteNumbers);

					byteArrays.push(byteArray);
				}

				return new Blob(byteArrays, {type: contentType});
			} catch (e) {
				//return false;
				return e;
			}
		};

		pub.cordova_upload_blob_new = function(b64Data) { // beware: used via cordova
			cordova_upload_blob_internal(b64Data, 'new');
		};

		pub.cordova_upload_blob = function(b64Data) { // beware: used via cordova
			cordova_upload_blob_internal(b64Data, 'old');
		};

		function cordova_upload_blob_internal(b64Data, method) { // beware: used via cordova
			const blob = (method === 'old' ? yalwa.mobile.cordova.b64_to_blob(b64Data, 'data:image/jpeg;base64,') : yalwa.mobile.cordova.dataURLtoBlob(b64Data));
			if (blob) {
				const $u = jQuery('.js-upload');
				const $input = last_file_input_clicked && jQuery(last_file_input_clicked).length ? jQuery(last_file_input_clicked) : $u;
				if ($input.length) {
					try {
						if ($input.data('blueimp-fileupload')) {
							$input.fileupload('add', {files: [blob]});
						} else {
							if (upload_timeout) {
								clearTimeout(upload_timeout);
							}
							upload_timeout = setTimeout(() => { // try again later
								cordova_upload_blob_internal(b64Data, method);
							}, 1000);
						}
					} catch (e) {
						if ($u.length && $u.data('blueimp-fileupload')) {
							$u.fileupload('add', {files: [blob]});
						} else {
							yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: no valid input file'));
						}
					}
				} else {
					yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: couldnt determine input file'));
				}
			} else {
				yalwa.basics.sentry.submit_error(new Error('cordova file upload problem: blob not supported'));
			}
		}

		pub.cordova_collect = function() { // beware: used via cordova
			var pending = yalwa.v.send_pending;
			if (pending) {
				yalwa.v.send_pending = null;
			}
			if(is_real_cordova() && !yalwa.basics.ss_get('ircs') && !is_real_cordova_check_in_progress) {
				send_is_real_cordova_check_result();
			}
			return {items: pending, timeout: 500};
		};

		let is_real_cordova_check_in_progress = false;
		
		function is_real_cordova() {
			if (
				yalwa.v.irc &&
				yalwa.v.is_phonegap &&
				(
					(
						yalwa.v.is_ios &&
						typeof window.webkit === 'object' &&
						typeof window.webkit.messageHandlers === 'object' &&
						typeof window.webkit.messageHandlers.cordova_iab === 'object'
					) ||
					!yalwa.v.is_ios &&
					typeof cordova_iab === 'object'
				)
			) {
				return true;
			} else {
				return false;
			}
		}
		
		function send_is_real_cordova_check_result() {
			is_real_cordova_check_in_progress = true;
			jQuery.ajax({
				url: '/api/ajax/general',
				data: {
					action: 'irc',
					irc: yalwa.v.irc
				},
				dataType: 'json',
				type: 'post',
				cache: false,
			}).done((response) => {
				is_real_cordova_check_in_progress = false;
				if (!response.success) {
					yalwa.basics.ss_set('ircs', true);
				} else {
					yalwa.basics.ss_set('ircs', true);
				}
			});
		}
		
		pub.openexternal = function(url) {
			if (yalwa.v.is_phonegap) {
				yalwa.mobile.cordova.cordova_send({action: 'openexternal', params: {url: url}});
			}
		};

		pub.receive_geolocation_success = function(position) {  // beware: used via cordova
			$document.trigger('geolocation_success.' + position.type, position);
		};

		pub.receive_geolocation_error = function(error_code) {  // beware: used via cordova
			if(yalwa.basics.get_routing() === 'dol_onboarding' || yalwa.basics.get_routing() === 'dol_nativeads_onboarding') {
				yalwa.dol.helper.location_problem_show();
				return;
			}
			display_geolocation_error(error_code);
		};

		pub.receive_stats = function(cordova_stats) {  // beware: used via cordova
			// only show dialog when installed for at least 7 days and app open since at least 5 minutes
			if (cordova_stats &&
				cordova_stats.first_launch &&
				cordova_stats.first_launch < (yalwa.basics.unix() - 60 * 60 * 24 * 7 * (yalwa.basics.ls_get('app_rating_later') ? parseInt(yalwa.basics.ls_get('app_rating_later')) : 1)) &&
				cordova_stats.page_count && cordova_stats.page_count > 100 &&
				!yalwa.mobile.generic_shadow.showing()
			) {
				yalwa.mobile.app_rating.show();
			}
		};

		pub.share_finished = function() {

		};

		pub.remove_backbutton = function() { // beware: used via cordova
			jQuery('.js-history_back').addClass('ybtb__li--disabled');
		};

		pub.activate_backbutton = function() { // beware: used via cordova
			jQuery('.js-history_back').removeClass('ybtb__li--disabled');
		};

		pub.on_resume = function(last_remote_url) {  // beware: used via cordova (iOS only currently)
			// not used yet
		};

		pub.get_country_list = function(list) {
			// no longer needed?
		};

		function new_tab_links(event) {
			event.preventDefault();
			if (yalwa.basics.yalwapp_version() >= 250) {
				if (jQuery(this).data('latitude') && jQuery(this).data('longitude')) {
					yalwa.basics.openwebintent(jQuery(this).prop('href'));
				} else if (url_is_external(jQuery(this).prop('href'))) {
					yalwa.mobile.cordova.openexternal(jQuery(this).prop('href'));
				} else if (jQuery(this).hasClass('js-force_second_webview')) {
					yalwa.basics.opensecondwebview(jQuery(this).prop('href'));
				} else if (jQuery(this).hasClass('js-open_webintent')) {
					yalwa.basics.openwebintent(jQuery(this).prop('href'));
				} else {
					yalwa.basics.navigate(jQuery(this).prop('href'));
				}
			} else {
				yalwa.mobile.cordova.openexternal(jQuery(this).prop('href'));
			}
		};

		function url_is_external(url) {
			var url_parsed = parse_url(url);
			if (url_parsed.hostname.search(/\blocanto\./) !== -1) {
				// handle internal PDFs in cordova
				if (url.search(/pdf\?s=/) !== -1 || url.search(/invoice\/\?id=/) !== -1) {
					return true;
				}
				return false;
			}
			return true;
		};

		function parse_url(url) {
			var a = document.createElement('a');
			a.href = url;
			return a;
		}

		return pub;

	}(pub.cordova));

	// safari doesnt support beforeunload and pagehide doesnt seem to work in inappbrowser
	pub.page_will_unload = function(url) {
		if (yalwa.basics.is_app()) {
			jQuery('#logo').addClass('indicate_loading');
		}
		if (yalwa.v.is_phonegap) {
			var disable_progress = false;
			if (url) {
				if (yalwa.v.is_ios && url.search(/maps\.(apple|google)/) !== -1) {
					disable_progress = true;
				}
				if (url.search('tel:') !== -1) {
					disable_progress = true;
				}
				if (url.search('locanto') === -1) {
					disable_progress = true;
				}
			}
			if (!disable_progress) {
				yalwa.mobile.app_progress();
			}
		}
	};

	pub.get_current_position = function(timeout, type) {
		if (yalwa.v.is_phonegap) {
			if(yalwa.v.is_dol_app) {
				yalwa.mobile.cordova_dol.cordova_send({action: 'geolocation', params: {type: type}});
			} else if (navigator && navigator.geolocation && !yalwa.v.is_dol_app && yalwa.basics.yalwapp_version() <= 271) {
				return navigator.geolocation.getCurrentPosition(
					function(position) {
						$document.trigger('geolocation_success.' + type, position);
					},
					function(error) {
						$document.trigger('geolocation_error.' + type, error);
					}, {
						timeout: timeout
					}
				);
			} else {
				// since on old inappbrowser do not fired loadstop event this can not be working but try once
				yalwa.mobile.cordova.cordova_send({action: 'geolocation', params: {type: type}});
			}
		} else {
			if (navigator && navigator.geolocation) {
				return navigator.geolocation.getCurrentPosition(
					function(position) {
						$document.trigger('geolocation_success.' + type, position);
					},
					function(error) {
						$document.trigger('geolocation_error.' + type, error);
					}, {
						timeout: timeout
					}
				);
			} else {
				$document.trigger('geolocation_error.' + type, null);
			}
		}
	};

	pub.is_mdot_domain = function() {
		return location.hostname.search(/^m\./) === 0;
	};

	pub.gestures = (function(pub) {

		pub = pub || {};

		var scrolling_in_progress = false;
		var current_pan_direction = null;
		var swiping_threshold = null;
		pub.init = function() {
			$window = jQuery(window);
			$document = jQuery(document);
			if (!jQuery('.js-main_col').length) {
				return;
			}
			if (yalwa.basics.get_routing() === 'dol_landing') {
				return; // to not set user-select: none on js-main_col
			}
			swiping_threshold = Math.min($window.width() / 4, 200);
			if (yalwa.mobile.htabs.is_active()) {
				$document.on('swipeforward', yalwa.mobile.htabs.next);
				$document.on('swipeback', yalwa.mobile.htabs.prev);
			}
			$document.on('swipeback_cancel swipeforward_cancel', swipe_cancel);
			jQuery('.js-main_col')
				.on('scroll.swipe_throttle', yalwa.basics.throttle(scrolling_yes, 50))
				.on('scroll.swipe_debounce', debounce);
			var h = new Hammer(jQuery('.js-main_col')[0], {});
			h.get('pan').set({direction: Hammer.DIRECTION_HORIZONTAL, threshold: 10});
			h
				.on('panstart', pan_start)
				.on('panleft panright', pan)
				.on('panend', pan_end);
			if(yalwa.v.is_dol) {
				h.destroy();
			}
			if(yalwa.v.is_ios) {
				jQuery('.js-main_col').on('scroll', yalwa.basics.throttle(ios_input_focus_fix, 400));
			}

		};

		pub.fake_next = function() {
			jQuery('.js-main_col').velocity('transition.slideRightBigIn', {duration: 250});
		};

		pub.fake_prev = function() {
			jQuery('.js-main_col').velocity('transition.slideLeftBigIn', {duration: 250});
		};

		function swipe_cancel(e, data) {
			jQuery('.js-main_col').velocity({translateX: ['0px', data.delta]}, {duration: 200});
		}

		function debounce() {
			yalwa.basics.debounce(scrolling_no, 400);
		}

		// Text insertion cursor (caret) appears above other elements in IOS mobile browser
		function ios_input_focus_fix() {
			if(document.activeElement.nodeName === 'INPUT') {
				jQuery(document.activeElement).blur();
			}
		}

		function scrolling_yes() {
			scrolling_in_progress = true;
		}

		function scrolling_no() {
			scrolling_in_progress = false;
		}

		function pan_start(e) {
			current_pan_direction = e.additionalEvent;
		}

		function check_abort(e) {
			if (current_pan_direction === 'panleft') {
				if (yalwa.mobile.htabs.swipe_active() && yalwa.mobile.htabs.swipe_next_possible()) {
					return false;
				}
			} else if (current_pan_direction === 'panright') {
				if (yalwa.mobile.htabs.swipe_active() && yalwa.mobile.htabs.swipe_prev_possible()) {
					return false;
				}
			}
			return true;
		}

		function pan(e) {
			if (check_abort(e)) {
				return;
			}
			var d = e.deltaX;
			window.requestAnimationFrame(function() {
				if (check_zero(d)) {
					d = 0;
				}
				jQuery('.js-main_col').css({transform: 'translateX(' + d.toString() + 'px)'});
			});
		}

		function check_zero(d) {
			if ((d > 0 && current_pan_direction === 'panleft') || (d < 0 && current_pan_direction === 'panright') || scrolling_in_progress) {
				return true;
			}
			return false;
		}

		function pan_end(e) {
			if (check_abort(e)) {
				return;
			}
			var d = e.deltaX;
			if (check_zero(d)) {
				d = 0;
			}
			if (Math.abs(d) > swiping_threshold) {
				$document.trigger(current_pan_direction === 'panleft' ? 'swipeforward' : 'swipeback', {delta: d});
			} else {
				$document.trigger(current_pan_direction === 'panleft' ? 'swipeforward_cancel' : 'swipeback_cancel', {delta: d});
			}
		}

		return pub;

	}(pub.gestures));

	pub.ali = (function(pub) {
		pub = pub || {};

		var bem = 'ali';

		pub.init = function() {
			jQuery('.js-ali_input').not('.js-ali_init_done').on('focus', on_focus).on('blur input change', on_blur).each(on_blur).addClass('js-ali_init_done');
			yalwa.mobile.init_reveal_password();
		};

		function on_focus() {
			jQuery(this).closest('.js-ali').addClass(bem + '--infocus');
		}

		function on_blur() {
			var $this = jQuery(this);
			if ($this.val() || ($this.prop('type') === 'date' && !yalwa.v.is_ios)) {
				on_focus.apply(this);
			} else {
				$this.closest('.js-ali').removeClass(bem + '--infocus');
			}
		}

		return pub;
	}(pub.ali));

	pub.app_rating = (function(pub) {

		pub = pub || {};

		function app_rating_open_store() {
			var url = appstore_url();
			if (yalwa.v.is_phonegap && url) {
				yalwa.basics.openwebintent(url);
			}
		}

		function app_rating_later() {
			yalwa.basics.ls_set('app_rating_later', (yalwa.basics.ls_get('app_rating_later') ? parseInt(yalwa.basics.ls_get('app_rating_later')) : 1) + 1);
		}

		function appstore_url() {
			if (yalwa.v.is_ios) {
				return yalwa.v.IOS_APP_URL;
			} else if (yalwa.v.ANDROID_APP_URL) {
				return yalwa.v.ANDROID_APP_URL;
			} else {
				yalwa.basics.sentry.submit_error(new Error('appstore link missing'));
				return null;
			}
		};

		function app_rating_dont_ask_again() {
			yalwa.mobile.cordova.cordova_send({action: 'forbid_app_rating', params: {value: true}});
		}

		function app_rating_ask_feedback(fl) {
			jQuery('.js-rating').remove();
			yalwa.basics.hide(jQuery('.js-appstore_rating_dialog_body'));
			yalwa.basics.show(jQuery('.js-appstore_rating_dialog_feedback'));
			var $rf = jQuery('.js-rating_feedback');
			yalwa.basics.show($rf);
			$rf.on('click', function() {
				if(yalwa.basics.ls_get('feedback_sent')) {
					fl.close();
					return false;
				}
				var value = jQuery('.js-rating_textarea').val();
				if (value) {
					jQuery('.js-rating_feedback').off('click');
					var $w = jQuery(window);
					jQuery.ajax({
						data: {
							feedback_type: 'locanto_app_android',
							page: window.location.href,
							feedback_text: value,
							feedback_mail: '',
							screen_width: $w.width(),
							screen_height: $w.height()
						},
						type: 'POST',
						url: '/' + yalwa.v.path_segment + '/run/feedback/'
					}).done(function(text) {
						if (text) {
							yalwa.basics.toast({message: text, type: 'success'});
							yalwa.basics.ls_set('feedback_sent', true);
						}
						fl.close();
					});
				} else {
					fl.close();
				}
			});
		}

		pub.check_opportunity = function() {
			if (yalwa.basics.ls_get('forbid_app_rating')) {
				return;
			}
			if (!yalwa.v.is_phonegap) {
				return;
			}
			if (yalwa.v.is_ios) {
				return;
			}
			yalwa.mobile.cordova.cordova_send({action: 'get_stats', params: {}});
		};

		pub.app_rating_clicked = function () {
			return pub.show();
		};

		pub.show = function() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/featherlight.min.js', function() {
				yalwa.basics.load_css(yalwa.v.css_path + 'featherlight.min.css');
				jQuery.ajax({
					data: {
						action: 'rating_dialog',
						os: yalwa.v.is_ios ? 'ios' : 'android'
					},
					type: 'GET',
					dataType: 'html',
					url: '/api/ajax/general'
				}).done(function(html) {
					var fl = jQuery.featherlight(html, {
						closeOnClick: false,
						//afterClose: app_rating_dont_ask_again
					});
					jQuery('.js-rating').on('click', function() {
						if (jQuery(this).data('rating') === 'later') {
							fl.close();
							app_rating_later();
							track('later')
						} else if (jQuery(this).data('rating') === 'good') {
							app_rating_dont_ask_again();
							fl.close();
							app_rating_open_store();
							track('good');
						} else {
							if(yalwa.basics.ls_get('feedback_sent')) {
								fl.close();
								return false;
							}
							app_rating_dont_ask_again();
							app_rating_ask_feedback(fl);
							track('bad_feedback');
						}
					});
				});
			});
		}

		function track(action, category = 'app_rating') {
			var deferred = jQuery.Deferred();
			if (!action) {
				deferred.resolve();
			}
			yalwa.basics.ga.event({
				category: category,
				action: action
			}).then(_=>{
				deferred.resolve();
			});

			return deferred.promise();
		}

		return pub;
	})(pub.app_rating);

	return pub;
}(yalwa.mobile));

yalwa.basics.init_wrapper(yalwa.mobile.init, 'jquery.min.js');
